// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-pagination.is-background .el-pager li[data-v-53ffc2b6]{background-color:#fff;color:#9e9e9e;display:inline-block;line-height:36px;min-width:36px;height:36px;margin:0 .4em;border:1px solid #fff}.el-pagination.is-background .el-pager li:not(.disabled).active[data-v-53ffc2b6]{background-color:#6a0387;color:#fff;display:inline-block;line-height:36px;min-width:36px;height:36px;margin:0 .4em;border:1px solid #6a0387}", ""]);
// Exports
module.exports = exports;
